import Settings from "../../utils/CarrotConfig"
import { SupportCenterLinks } from "../../utils/SupportCenterLinks"
import { goToMobileHelpCenter, isMobileApp } from "./MobileNativeClient"
import { MouseEvent } from "react"

const SupportCenterBaseUri = Settings.ZENDESK_GUIDE

const parseZendeskFragmentFromUrl = (url: string) => {
  const path = url?.split("/")
  return path[path.length - 2] + "/" + path[path.length - 1]
}

const goToHelpCenter = async (event: MouseEvent<HTMLAnchorElement>, link?: string) => {
  if (isMobileApp()) {
    event.preventDefault()
    await goToMobileHelpCenter(link)
  }
}

const goToHelpCenterLegacy = async (link?: SupportCenterLinks) => {
  if (isMobileApp()) {
    await goToMobileHelpCenter(link)
  } else {
    window.open(getSupportCenterLink(link), "_blank")
  }
}

const getSupportCenterLink = (link?: string) => {
  return isNullOrUndefined(link) ? SupportCenterBaseUri : `${SupportCenterBaseUri}/${link}`
}

// @ts-expect-error TS7006
const isNullOrUndefined = (link) => {
  return typeof link === "undefined" || link == null
}

// @ts-expect-error TS7006
const isZendeskLink = (href) => {
  try {
    const url = new URL(href)
    return url?.host?.match(/\.*\.zendesk\.com/)
  } catch (e) {
    return false
  }
}

export { goToHelpCenterLegacy, goToHelpCenter, getSupportCenterLink, isZendeskLink, parseZendeskFragmentFromUrl }
